import React from 'react'; 

import {  getTypeClg } from "../../common/common" 

import { IcSCTips } from "../../common/svg"

export const TipBox = ({ searchTip }) => {

    const tipClg = getTypeClg(searchTip.type)
    
    return (
        <div className="m-container"> 
            <div className={`search-tip ${tipClg}`}> 
                <div className="wrap-svg">
                    <IcSCTips />
                </div>
                <p className="fontWeight-6">{searchTip.message}</p>
            </div>
      </div>
    )
}